import type { ReactNode } from 'react';
import styles from './InfoTag.module.css';

type InfoTagProps = {
  children: ReactNode;
  leading?: ReactNode;
  variant?: 'default' | 'accent' | 'negative';
  title?: string;
};

export default function InfoTag({ children, leading, variant = 'default', title }: InfoTagProps) {
  return (
    <span
      className={[styles.tag, variant === 'accent' ? styles.accent : variant === 'negative' ? styles.negative : null].filter(Boolean).join(' ')}
      title={title}
    >
      {leading}
      <span>{children}</span>
    </span>
  );
}
